import React, { FC } from 'react';
import propTypes from 'prop-types';
import { FiZap, FiZapOff } from 'react-icons/fi';

import { usePreferences } from '../../../../utility/usePreferences';
import { useTranslation } from 'react-i18next';

enum Provider {
  PARKSPACE = 'parkspace',
  PARKIT = 'parkit'
}

interface ISaleItemSourceProps {
  source: string;
}

const SaleItemSource: FC<ISaleItemSourceProps> = ({ source }) => {
  const preferences = usePreferences();
  const { t } = useTranslation();
  if (!preferences.isUsingDynamicProductCatalog()) {
    return null;
  }

  const [provider, tag] = source.split(':');
  if (provider !== Provider.PARKSPACE) {
    return null;
  }

  const isFallback = tag === 'fallback';
  if (isFallback) {
    return <FiZapOff title={t("saleItem.livePriceNotRetrieved")} />;
  }

  return <FiZap title={t("saleItem.livePrice")} />;
}

SaleItemSource.propTypes = {
  source: propTypes.string.isRequired,
}

export default SaleItemSource;
